var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"waiter",class:{'waiter--active': _vm.isLoading }},[_c('div',{staticClass:"waiter__spinner"},[_c('b-spinner',{attrs:{"label":"Loading..."}})],1),_c('div',{staticClass:"waiter__wpapper"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }